import {$$} from './$$';

/**
 * https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
 */

export interface FocusTrap {
    enable(): void;

    disable(): void;
}

const KEY_TAB: string = 'Tab';

export function focusTrap(element: HTMLElement): FocusTrap {
    let elements: HTMLElement[];

    function findElements(): void {
        elements = $$(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            element,
        ).filter((el: HTMLElement): boolean => {
            const isNotDisabled: boolean =
                el.getAttribute('disabled') !== 'true';
            const isVisible: boolean = el.offsetParent !== null;

            return isNotDisabled && isVisible;
        });
    }

    function check(event: KeyboardEvent): void {
        if (event.key !== KEY_TAB) {
            return;
        }

        event.preventDefault();

        if (elements.length === 0) {
            return;
        }

        const offset: number = event.shiftKey ? -1 : 1;
        let index: number = elements.indexOf(
            <HTMLElement>document.activeElement,
        );

        index += offset;

        if (index >= elements.length) {
            index = 0;
        } else if (index < 0) {
            index = elements.length - 1;
        }

        elements[index].focus();
    }

    return {
        enable(): void {
            findElements();

            window.addEventListener('keydown', check);
        },
        disable(): void {
            window.removeEventListener('keydown', check);
        },
    };
}
